import tw from 'twin.macro'

const Button = tw.a`
  border-2 text-base block font-serif px-5 py-1 mb-2
  transition ease-in-out duration-150
  hover:(bg-white cursor-pointer text-gray-800)
  sm:(inline-block mb-0)
`

export default Button